import AdminHeader from '../components/common/AdminHeader';
import PricingManagementComponent from '../components/pricing/PricingManagement';
import PermissionGuard from '../components/common/PermissionGuard';

export default function PricingManagement() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {/* <PermissionGuard screen="masterprices || subscriptionPlans"> */}
          <PricingManagementComponent />
        {/* </PermissionGuard> */}
      </main>
    </div>
  );
}
